export default __webpack_public_path__ + "static/media/re1.faa4fc0f.png";